import React from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
  width: 100%;
`;

const Label = styled.label`
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: var(--primary-color);
  font-size: 1.15rem;
  font-family: "Cormorant Garamond", serif;
  letter-spacing: 1px;
`;

const StyledInput = styled.input`
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius);
  font-size: 1rem;
  background-color: var(--background-tertiary);
  color: var(--text-color);
  transition: var(--transition);

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.2);
  }

  &::placeholder {
    color: var(--text-tertiary);
  }

  ${(props) =>
    props.error &&
    `
    border-color: var(--error-color);
    
    &:focus {
      border-color: var(--error-color);
      box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.2);
    }
  `}
`;

const TextArea = styled(StyledInput).attrs({ as: "textarea" })`
  min-height: 120px;
  resize: vertical;
`;

const ErrorMessage = styled.p`
  color: var(--error-color);
  font-size: 0.85rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
`;

const Input = ({
  label,
  type = "text",
  error,
  multiline,
  register,
  ...props
}) => {
  const InputComponent = multiline ? TextArea : StyledInput;

  return (
    <InputWrapper>
      {label && <Label>{label}</Label>}
      <InputComponent type={type} error={error} {...register} {...props} />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};

export default Input;
